<script setup lang="ts">
import { useForemanApiKeys } from '@/composables/core/foreman-api-keys'
import { useSiteMap } from '@/composables/eos/site-map'
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import type { TabsPaneContext } from 'element-plus'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const activeTab = computed(() => router.currentRoute.value.name?.toString())
const previousRoute = ref()

const { getApiKeyQuery } = useForemanApiKeys()
const { syncSiteMapMutation } = useSiteMap()
const { data: apiKey } = getApiKeyQuery()

const handleTabClick = (tab: TabsPaneContext) => {
  router.push({ name: tab.props.name!.toString() })
}

const handleSync = () => {
  syncSiteMapMutation.mutate()
}

// Store the previous route when component is mounted
onMounted(() => {
  // Get the previous route from router's history
  // Adjusted to type safety with TypeScript
  previousRoute.value = router.options.history.state.back
})
</script>

<template>
  <ViewLayout title="Infrastructure">
    <template #controls>
      <el-button v-if="apiKey" type="primary" @click="handleSync">Sync With Foreman</el-button>
    </template>
    <template #navigation>
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="Structures" name="eos-site-map-structures" />
        <el-tab-pane label="Racks" name="eos-site-map-racks" />
        <el-tab-pane label="Miners" name="eos-site-map-miners" />
      </el-tabs>
    </template>
    <div class="flex-1 flex flex-col gap-6">
      <router-view />
    </div>
  </ViewLayout>
</template>

<style scoped lang="scss">
@use '@/styles/element/overrides';

:deep() {
  @include overrides.custom-el-tabs;
}
</style>
